import classNames from "classnames";
import Flex from "@/components-library/layout/flex";
import PropTypes from "prop-types";

import classes from "./text-field.module.scss";

function TextField({
  isEnabled,
  type,
  name,
  label,
  value,
  error,
  min,
  max,
  step,
  size,
  className,
  style,
  onChange,
}) {
  return (
    <Flex
      direction="column"
      align="flex-start"
      className={classNames(classes.textField, className, {
        [classes.disabled]: !isEnabled,
      })}
      style={style}
    >
      <label
        htmlFor={name}
        className={classNames(classes.label, classes[size], {
          [classes.error]: error,
        })}
      >
        {label}
      </label>

      <input
        disabled={!isEnabled}
        type={type}
        id={name}
        name={name}
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={onChange}
        className={classNames(classes.input, classes[size])}
      />

      {error && <div className={classes.errorMessage}>{error}</div>}
    </Flex>
  );
}

TextField.sizes = ["xs", "sm", "md", "lg", "xl"];
TextField.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  size: PropTypes.oneOf(TextField.sizes).isRequired,
  className: PropTypes.string.isRequired,
  style: PropTypes.object,
  onChange: PropTypes.func,
};

TextField.defaultProps = {
  isEnabled: true,
  type: "text",
  value: "",
  className: "",
  size: "lg",
};

export default TextField;
